import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ImageCollection from "../../../components/ImageCollection";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArtDirection = makeShortcode("ArtDirection");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Materials and finishes create a tactile sense of character within our environments. Material selection and color strategy are informed by our design characteristics and a consistent point of view. These themes represent a coherent experience that can be shared by clients and IBM employees globally. The workplace should feel symbiotic, illuminating, welcoming, localized and connected. We have identified two categories of finishes that work together to create a flexible system to meet any project need—base and accent.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Base finishes</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accent finishes</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Palette examples</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Glass and metal</AnchorLink>
    </AnchorLinks>
    <h2>{`Base finishes`}</h2>
    <p>{`Base finishes represent the dominant materials within a space. Applications might include flooring, ceiling and wall treatments, or millwork.
IBM environments may be characterized by both natural and engineered materials. Embracing the concept of duality, our base finishes maintain tension and contrast between natural and engineered substrates. Use of wood should appear in all environments to maintain a sense of warmth and continuity. Material specification may vary based on project needs, design concept and budget.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUEBv/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAG3l0SC0I5On58mUI//xAAcEAABBAMBAAAAAAAAAAAAAAABAAIDEhExMjP/2gAIAQEAAQUCOnuFbhP4mcKWCk4n88r/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAVEQEBAAAAAAAAAAAAAAAAAAABIP/aAAgBAgEBPwFY/8QAGhAAAgIDAAAAAAAAAAAAAAAAAAECEDEycf/aAAgBAQAGPwIybIdy5f8A/8QAHRAAAgIBBQAAAAAAAAAAAAAAAAERIWEQMVFxsf/aAAgBAQABPyF79Cd0FGFG4OV3M+me6JH/2gAMAwEAAgADAAAAEATwP//EABYRAQEBAAAAAAAAAAAAAAAAAAERIP/aAAgBAwEBPxABK4//xAAWEQEBAQAAAAAAAAAAAAAAAAABEEH/2gAIAQIBAT8QQQCbP//EABoQAQADAQEBAAAAAAAAAAAAAAEAESExkXH/2gAIAQEAAT8QIdcjAss1YUBV9htODZZl8Okqy3k8SjRJJs7P/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "palette of base finishes",
            "title": "palette of base finishes",
            "src": "/workplace-xg/static/7cdd63b72f2fb4733f9316c706a8ceb7/2e753/palette-of-base-finishes.jpg",
            "srcSet": ["/workplace-xg/static/7cdd63b72f2fb4733f9316c706a8ceb7/69549/palette-of-base-finishes.jpg 288w", "/workplace-xg/static/7cdd63b72f2fb4733f9316c706a8ceb7/473e3/palette-of-base-finishes.jpg 576w", "/workplace-xg/static/7cdd63b72f2fb4733f9316c706a8ceb7/2e753/palette-of-base-finishes.jpg 1152w", "/workplace-xg/static/7cdd63b72f2fb4733f9316c706a8ceb7/17a8a/palette-of-base-finishes.jpg 1210w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`Lead with white`}</h3>
    <p>{`At least 50% of the base finishes should be light in value. Spaces should always lead with white to achieve an atmosphere that’s positive and optimistic. Material choice is flexible based on budget and design intent. Predominantly light interiors provide a backdrop for natural wood tones, accent colors, feature elements and environmental graphics to be highlighted.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFAgT/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABu441S1BQn//EABoQAAIDAQEAAAAAAAAAAAAAAAABAxEyAhL/2gAIAQEAAQUCbo9o5dqTZDj/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAwEBPwGH/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Bp//EABkQAQACAwAAAAAAAAAAAAAAAAACECExgf/aAAgBAQAGPwJthJyv/8QAGxABAAICAwAAAAAAAAAAAAAAAQARIUFRgeH/2gAIAQEAAT8hqLOQQLlZG16qC4Ne477z/9oADAMBAAIAAwAAABBXP//EABYRAQEBAAAAAAAAAAAAAAAAAAABIf/aAAgBAwEBPxAuV//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAgEBPxCjpt//xAAaEAEBAQADAQAAAAAAAAAAAAABEQAhMUFR/9oACAEBAAE/EKBAPXROHxe/NGSkpnLb4PXRhQhTgJjCv1v/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "comparison of base finish palette color selection",
              "title": "comparison of base finish palette color selection",
              "src": "/workplace-xg/static/ceab9c2634712a3580ff463689ad223d/473e3/comparison-of-base-finish-palette-color-selection-mobile.jpg",
              "srcSet": ["/workplace-xg/static/ceab9c2634712a3580ff463689ad223d/69549/comparison-of-base-finish-palette-color-selection-mobile.jpg 288w", "/workplace-xg/static/ceab9c2634712a3580ff463689ad223d/473e3/comparison-of-base-finish-palette-color-selection-mobile.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIFAwT/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABuJxrLSMRP//EABoQAAIDAQEAAAAAAAAAAAAAAAABAhIyAxH/2gAIAQEAAQUCb8Loi7KWjjj/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAwEBPwGH/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Bp//EABkQAQACAwAAAAAAAAAAAAAAAAACECExgf/aAAgBAQAGPwJthJyv/8QAHBAAAwABBQAAAAAAAAAAAAAAAAERITFBUWGx/9oACAEBAAE/IZ27Dq6CaNTNL5E8pbD2P//aAAwDAQACAAMAAAAQSD//xAAWEQEBAQAAAAAAAAAAAAAAAAAAATH/2gAIAQMBAT8QLr//xAAWEQEBAQAAAAAAAAAAAAAAAAAAASH/2gAIAQIBAT8QJsf/xAAcEAEAAwACAwAAAAAAAAAAAAABABEhMXFBUbH/2gAIAQEAAT8QJQgeVqFItDbNyPKi6sI3WFseyJqrwnTErv3+E//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "comparison of base finish palette color selection",
              "title": "comparison of base finish palette color selection",
              "src": "/workplace-xg/static/7d75de43e8fa00d986e240a55d03a783/2e753/comparison-of-base-finish-palette-color-selection-desktop.jpg",
              "srcSet": ["/workplace-xg/static/7d75de43e8fa00d986e240a55d03a783/69549/comparison-of-base-finish-palette-color-selection-desktop.jpg 288w", "/workplace-xg/static/7d75de43e8fa00d986e240a55d03a783/473e3/comparison-of-base-finish-palette-color-selection-desktop.jpg 576w", "/workplace-xg/static/7d75de43e8fa00d986e240a55d03a783/2e753/comparison-of-base-finish-palette-color-selection-desktop.jpg 1152w", "/workplace-xg/static/7d75de43e8fa00d986e240a55d03a783/74f4b/comparison-of-base-finish-palette-color-selection-desktop.jpg 1728w", "/workplace-xg/static/7d75de43e8fa00d986e240a55d03a783/f35b7/comparison-of-base-finish-palette-color-selection-desktop.jpg 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2>{`Accent finishes`}</h2>
    <p>{`Accent finishes add texture, detail and color—creating focal points within an environment. Applications may include textiles, carpet, upholstery or furniture.`}</p>
    <p>{`Use color with purpose. Color should be integrated into accent palettes with intention. Neutral, monochromatic, complementary and analogous palettes may be applied based on space type. Accent colors should work within IBM’s brand palette. Additional colors may be introduced on a case-by-case basis where appropriate. Learn more about the `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/color"
      }}>{`IBM color palette`}</a>{`.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAUDBAL/xAAXAQADAQAAAAAAAAAAAAAAAAACAwQB/9oADAMBAAIQAxAAAAHxz0sHzy1QZ0cyN3YCz//EAB0QAAICAQUAAAAAAAAAAAAAAAECAAMSERMUMTL/2gAIAQEAAQUCtYuTqAcpg2O0zTjWQ9V+5//EABkRAAEFAAAAAAAAAAAAAAAAAAABAhARIf/aAAgBAwEBPwFWaVP/xAAZEQEAAgMAAAAAAAAAAAAAAAABAAIDEBP/2gAIAQIBAT8BpnQnd3//xAAbEAACAQUAAAAAAAAAAAAAAAABEEEAESAxkf/aAAgBAQAGPwLRUqwqO4f/xAAdEAACAQQDAAAAAAAAAAAAAAABEQAQITFxQZGx/9oACAEBAAE/IXUK1LwAXGFqC0LdzgD3QM+p5U//2gAMAwEAAgADAAAAEL/PvP/EABoRAAICAwAAAAAAAAAAAAAAAAABEBEhQVH/2gAIAQMBAT8Qe0wX4aj/xAAZEQEAAgMAAAAAAAAAAAAAAAABABARQWH/2gAIAQIBAT8QxhCcibr/xAAbEAEAAgMBAQAAAAAAAAAAAAABABEQIUFxYf/aAAgBAQABPxAIgUtjrI4S3Sr7AIDrdQvq7bpPliJ6esf/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "palette of accent finishes",
            "title": "palette of accent finishes",
            "src": "/workplace-xg/static/54b841ec7b5ce065bc2930c779e5487e/2e753/palette-of-accent-finishes.jpg",
            "srcSet": ["/workplace-xg/static/54b841ec7b5ce065bc2930c779e5487e/69549/palette-of-accent-finishes.jpg 288w", "/workplace-xg/static/54b841ec7b5ce065bc2930c779e5487e/473e3/palette-of-accent-finishes.jpg 576w", "/workplace-xg/static/54b841ec7b5ce065bc2930c779e5487e/2e753/palette-of-accent-finishes.jpg 1152w", "/workplace-xg/static/54b841ec7b5ce065bc2930c779e5487e/a052a/palette-of-accent-finishes.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`Texture and dynamism`}</h3>
    <p>{`Accent finishes add texture and dynamism to our spaces. The overall impression should be welcoming and warm to help every employee, client and visitor experience the hospitality of IBM. Integration of local context, geography and culture through material, pattern and texture creates a sense of place and belonging within the workplace. By building a connected environment, IBM celebrates individual and global communities of IBM employees and their clients.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABQBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAdeedaagsH//xAAcEAEBAAEFAQAAAAAAAAAAAAABAwIEERITFCH/2gAIAQEAAQUCpkhzqEM+ydF9Cu+k+R//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPwFJ/8QAFhEAAwAAAAAAAAAAAAAAAAAAEBFB/9oACAECAQE/AXB//8QAHBAAAgICAwAAAAAAAAAAAAAAABECIQESMUGB/9oACAEBAAY/As64scklYyUekaulwen/xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMUFRYYH/2gAIAQEAAT8hGcUxeoV7UlEWyjl0Rzny+QgKu/HMBQdp/9oADAMBAAIAAwAAABCgL//EABYRAAMAAAAAAAAAAAAAAAAAABARQf/aAAgBAwEBPxBlH//EABcRAQEBAQAAAAAAAAAAAAAAAAEAIRH/2gAIAQIBAT8QMYl63//EABsQAQEAAwEBAQAAAAAAAAAAAAERACExQWFx/9oACAEBAAE/EKRrGwrX3Bt4IGS8j+ZyVIYcx/r6ecOCYWg7a8YIGGH/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "comparison of accent finish palette color selection",
              "title": "comparison of accent finish palette color selection",
              "src": "/workplace-xg/static/393f22fbff1e0c85922bb4c07e94cb04/473e3/comparison-of-accent-finish-palette-color-selection-mobile.jpg",
              "srcSet": ["/workplace-xg/static/393f22fbff1e0c85922bb4c07e94cb04/69549/comparison-of-accent-finish-palette-color-selection-mobile.jpg 288w", "/workplace-xg/static/393f22fbff1e0c85922bb4c07e94cb04/473e3/comparison-of-accent-finish-palette-color-selection-mobile.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEDBAX/xAAUAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHqwkk2CB//xAAcEAADAAEFAAAAAAAAAAAAAAABAgMEERITITH/2gAIAQEAAQUCozabqhcenIh7qfcYAT//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPwFJ/8QAFhEBAQEAAAAAAAAAAAAAAAAAERAh/9oACAECAQE/AXCf/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAECESExQVH/2gAIAQEABj8Cajh+styTVZLvpNPRXK0Y9P/EABkQAQADAQEAAAAAAAAAAAAAAAEAESExYf/aAAgBAQABPyHPpcTIDGFkRFduOTXF1l+wZu+rIrBUf//aAAwDAQACAAMAAAAQAy//xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QBdn/xAAXEQEBAQEAAAAAAAAAAAAAAAABABFB/9oACAECAQE/EDkl12//xAAcEAEBAAICAwAAAAAAAAAAAAABEQAhMUFRYXH/2gAIAQEAAT8Qo1ogHI842e6I2DxD5jWnYWJo1jaoNinDrIAFoQ+j1ZkgC2X0Z//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "comparison of accent finish palette color selection",
              "title": "comparison of accent finish palette color selection",
              "src": "/workplace-xg/static/4ce77140dc7dfcd389268c75ce5770ef/2e753/comparison-of-accent-finish-palette-color-selection-desktop.jpg",
              "srcSet": ["/workplace-xg/static/4ce77140dc7dfcd389268c75ce5770ef/69549/comparison-of-accent-finish-palette-color-selection-desktop.jpg 288w", "/workplace-xg/static/4ce77140dc7dfcd389268c75ce5770ef/473e3/comparison-of-accent-finish-palette-color-selection-desktop.jpg 576w", "/workplace-xg/static/4ce77140dc7dfcd389268c75ce5770ef/2e753/comparison-of-accent-finish-palette-color-selection-desktop.jpg 1152w", "/workplace-xg/static/4ce77140dc7dfcd389268c75ce5770ef/74f4b/comparison-of-accent-finish-palette-color-selection-desktop.jpg 1728w", "/workplace-xg/static/4ce77140dc7dfcd389268c75ce5770ef/f35b7/comparison-of-accent-finish-palette-color-selection-desktop.jpg 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2>{`Palette examples`}</h2>
    <h3>{`Monochromatic`}</h3>
    <p>{`Welcome and Arrival zones should feature thoughtful blue accents within architectural finishes.`}</p>
    <p>{`Blue serves as another expression of our brand identity. This monochromatic treatment showcases blue in unique and unexpected details. Blue should be applied with intention and treated with the same level of thoughtfulness as our logo.`}</p>
    <p>{`The tonal nature of the surrounding finishes and textures accentuate a restrained use of blue, creating a focal point within the reception desk. A natural wood finish balances the cool gray tones within the flooring and walls.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAf/EABYBAQEBAAAAAAAAAAAAAAAAAAIBA//aAAwDAQACEAMQAAABuoswTdJpqf/EABwQAAEEAwEAAAAAAAAAAAAAAAIAAQMxEhMhMv/aAAgBAQABBQInxaTq2ipvM9jX/8QAFhEBAQEAAAAAAAAAAAAAAAAAACFB/9oACAEDAQE/AcV//8QAGBEAAgMAAAAAAAAAAAAAAAAAABEhIlH/2gAIAQIBAT8Bcoph/8QAGRAAAgMBAAAAAAAAAAAAAAAAAhAAASFB/9oACAEBAAY/Atllxkv/xAAcEAEAAgEFAAAAAAAAAAAAAAABADFBEBEhcZH/2gAIAQEAAT8hHcjhPCJ5fJT3E2NaH//aAAwDAQACAAMAAAAQaC//xAAXEQADAQAAAAAAAAAAAAAAAAAAATFx/9oACAEDAQE/EGqNH//EABoRAAEFAQAAAAAAAAAAAAAAAAABETFRkeH/2gAIAQIBAT8QSUPZvD//xAAbEAEAAwEAAwAAAAAAAAAAAAABABEhQTFxof/aAAgBAQABPxC+SC1hcHE2q44bEqW9KfBhzCORa8RNZ//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "monochromatic color palette",
            "title": "monochromatic color palette",
            "src": "/workplace-xg/static/3482f3bdb32757b3257d49e6bab62f93/2e753/monochromatic-color-palette.jpg",
            "srcSet": ["/workplace-xg/static/3482f3bdb32757b3257d49e6bab62f93/69549/monochromatic-color-palette.jpg 288w", "/workplace-xg/static/3482f3bdb32757b3257d49e6bab62f93/473e3/monochromatic-color-palette.jpg 576w", "/workplace-xg/static/3482f3bdb32757b3257d49e6bab62f93/2e753/monochromatic-color-palette.jpg 1152w", "/workplace-xg/static/3482f3bdb32757b3257d49e6bab62f93/74f4b/monochromatic-color-palette.jpg 1728w", "/workplace-xg/static/3482f3bdb32757b3257d49e6bab62f93/f35b7/monochromatic-color-palette.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row className="mt-32" mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBAgT/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB0qZaV5In/8QAGRABAQEAAwAAAAAAAAAAAAAAAgEDERIi/9oACAEBAAEFAsT41K7Z5QkWwq0zNcj/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAVEQEBAAAAAAAAAAAAAAAAAAAQQf/aAAgBAgEBPwGH/8QAHBAAAQMFAAAAAAAAAAAAAAAAAAEQMREhQYGh/9oACAEBAAY/AjNGgvwSdn//xAAaEAADAQADAAAAAAAAAAAAAAAAASERMUFR/9oACAEBAAE/IXOntOGYoKdbrJsdhTRvtbJ6P//aAAwDAQACAAMAAAAQZN//xAAWEQADAAAAAAAAAAAAAAAAAAABEDH/2gAIAQMBAT8QFX//xAAVEQEBAAAAAAAAAAAAAAAAAAABAP/aAAgBAgEBPxBgF//EABoQAQEBAQEBAQAAAAAAAAAAAAERACFxMVH/2gAIAQEAAT8QqSZFn0yEsiwYHuF0FR/XPqLVCkeZKp4JAIr73dYFJBSM7N//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "monochromatic color palette in lobby",
            "title": "monochromatic color palette in lobby",
            "src": "/workplace-xg/static/35e5231a7eabde3e72774d1c65e37234/2e753/monochromatic-color-palette-in-lobby.jpg",
            "srcSet": ["/workplace-xg/static/35e5231a7eabde3e72774d1c65e37234/69549/monochromatic-color-palette-in-lobby.jpg 288w", "/workplace-xg/static/35e5231a7eabde3e72774d1c65e37234/473e3/monochromatic-color-palette-in-lobby.jpg 576w", "/workplace-xg/static/35e5231a7eabde3e72774d1c65e37234/2e753/monochromatic-color-palette-in-lobby.jpg 1152w", "/workplace-xg/static/35e5231a7eabde3e72774d1c65e37234/74f4b/monochromatic-color-palette-in-lobby.jpg 1728w", "/workplace-xg/static/35e5231a7eabde3e72774d1c65e37234/977ea/monochromatic-color-palette-in-lobby.jpg 1850w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`Analogous`}</h3>
    <p>{`Embracing diversity, Connect and Collaborate spaces should use a broader spectrum of color.`}</p>
    <p>{`Vibrant accent colors activate our Collaboration areas. Balance color selections with neutral surrounding finishes and furniture. Use wood within walls, flooring or furniture to maintain continuity with other space types. Coordinate color selections with adjacent environmental graphics and signage. Learn more about `}<a parentName="p" {...{
        "href": "/workplace-xg/brand-expression/overview"
      }}>{`brand expression`}</a>{`.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAE/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/2gAMAwEAAhADEAAAAXQmQDbYqa//xAAdEAABAwUBAAAAAAAAAAAAAAABAAIDBBESEzIz/9oACAEBAAEFAnGwmINRkFLzL67HL//EABYRAQEBAAAAAAAAAAAAAAAAAAABE//aAAgBAwEBPwFpH//EABYRAQEBAAAAAAAAAAAAAAAAAAABEv/aAAgBAgEBPwFiP//EABYQAAMAAAAAAAAAAAAAAAAAAAAg4f/aAAgBAQAGPwJYf//EABwQAQACAQUAAAAAAAAAAAAAAAEAETFBUXGRsf/aAAgBAQABPyE7mKUxZOSe8dJNKhvnSf/aAAwDAQACAAMAAAAQAz//xAAWEQEBAQAAAAAAAAAAAAAAAAAAAWH/2gAIAQMBAT8QjB//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/EC//xAAdEAACAQQDAAAAAAAAAAAAAAABEQAhMUGRYXHw/9oACAEBAAE/EAZqaoHDhFsPAhOb6S30hKYLBqED3an/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "analogous color palette",
            "title": "analogous color palette",
            "src": "/workplace-xg/static/c85f81aafde200f3599cab25da524c1d/2e753/analogous-color-palette.jpg",
            "srcSet": ["/workplace-xg/static/c85f81aafde200f3599cab25da524c1d/69549/analogous-color-palette.jpg 288w", "/workplace-xg/static/c85f81aafde200f3599cab25da524c1d/473e3/analogous-color-palette.jpg 576w", "/workplace-xg/static/c85f81aafde200f3599cab25da524c1d/2e753/analogous-color-palette.jpg 1152w", "/workplace-xg/static/c85f81aafde200f3599cab25da524c1d/74f4b/analogous-color-palette.jpg 1728w", "/workplace-xg/static/c85f81aafde200f3599cab25da524c1d/99672/analogous-color-palette.jpg 1852w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row className="mt-32" mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGZ0NcusKE//8QAHRAAAQQCAwAAAAAAAAAAAAAAAgABAwQREhMhMv/aAAgBAQABBQI4w5a4aS5ZP29b2MYL/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAQQDAQAAAAAAAAAAAAAAAAECESEQMUFR/9oACAEBAAY/AnNpseCpM0bwotdP/8QAGxABAAMAAwEAAAAAAAAAAAAAAQARMSFRwWH/2gAIAQEAAT8h4oDCvJwJyGHTK+zYtrNnR7HX22Z//9oADAMBAAIAAwAAABCoH//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABYRAQEBAAAAAAAAAAAAAAAAAAARIf/aAAgBAgEBPxCYj//EABoQAQADAQEBAAAAAAAAAAAAAAEAESFhQVH/2gAIAQEAAT8QwEmpa0Y67uQayNA/UjxBypEGxqOAqraw16hTmIo5Vpbqh2f/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "analogous color palette in play spaces",
            "title": "analogous color palette in play spaces",
            "src": "/workplace-xg/static/649beb6ae3949520ebae2ba23ab2607a/2e753/analogous-color-palette-in-play-spaces.jpg",
            "srcSet": ["/workplace-xg/static/649beb6ae3949520ebae2ba23ab2607a/69549/analogous-color-palette-in-play-spaces.jpg 288w", "/workplace-xg/static/649beb6ae3949520ebae2ba23ab2607a/473e3/analogous-color-palette-in-play-spaces.jpg 576w", "/workplace-xg/static/649beb6ae3949520ebae2ba23ab2607a/2e753/analogous-color-palette-in-play-spaces.jpg 1152w", "/workplace-xg/static/649beb6ae3949520ebae2ba23ab2607a/74f4b/analogous-color-palette-in-play-spaces.jpg 1728w", "/workplace-xg/static/649beb6ae3949520ebae2ba23ab2607a/f35b7/analogous-color-palette-in-play-spaces.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`Neutral`}</h3>
    <p>{`Neutral material palettes support dynamic applications of texture, light and art. Neutral environments often use dynamic texture and pattern that establish movement and tension within the space. The example shown here is a linear ceiling system that’s interrupted with curvilinear geometry and seating configurations.`}</p>
    <p>{`The use of color in the space is minimal, creating a focal point for fine art or branded elements. Use neutral palettes to balance moments of high saturation and energy.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAG4q1KlkGAn/8QAGRAAAgMBAAAAAAAAAAAAAAAAAjEAAQMS/9oACAEBAAEFAjWhVWfNwluhX//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/ASf/xAAWEQADAAAAAAAAAAAAAAAAAAABECH/2gAIAQIBAT8BMX//xAAZEAACAwEAAAAAAAAAAAAAAAACEAARQXH/2gAIAQEABj8ChDtM+L//xAAbEAACAgMBAAAAAAAAAAAAAAAAAUFxEBEx8P/aAAgBAQABPyFNpYwUmDlY79oGcj//2gAMAwEAAgADAAAAEFjv/8QAFhEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EAq//8QAFxEBAAMAAAAAAAAAAAAAAAAAAAERMf/aAAgBAgEBPxCWlP/EABkQAAIDAQAAAAAAAAAAAAAAAAABESExkf/aAAgBAQABPxBiS0P7ajRFWhQYulQbkIW3T//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "neutral finish palette",
            "title": "neutral finish palette",
            "src": "/workplace-xg/static/37cc7b881d5a12b714894be5be94c496/2e753/neutral-finish-palette.jpg",
            "srcSet": ["/workplace-xg/static/37cc7b881d5a12b714894be5be94c496/69549/neutral-finish-palette.jpg 288w", "/workplace-xg/static/37cc7b881d5a12b714894be5be94c496/473e3/neutral-finish-palette.jpg 576w", "/workplace-xg/static/37cc7b881d5a12b714894be5be94c496/2e753/neutral-finish-palette.jpg 1152w", "/workplace-xg/static/37cc7b881d5a12b714894be5be94c496/74f4b/neutral-finish-palette.jpg 1728w", "/workplace-xg/static/37cc7b881d5a12b714894be5be94c496/977ea/neutral-finish-palette.jpg 1850w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row className="mt-32" mdxType="Row">
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIEAf/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABrbZMtwg3/8QAGxAAAgMAAwAAAAAAAAAAAAAAAAIBAxESEyL/2gAIAQEAAQUC5nkXJWypJOpBIxf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAZEAACAwEAAAAAAAAAAAAAAAAAEQEhMQL/2gAIAQEABj8CswpDnmzBQf/EABwQAQACAQUAAAAAAAAAAAAAAAEAESExQWGB0f/aAAgBAQABPyEINS7qjMVgurO8JldJjxyjZ6YRBQT/2gAMAwEAAgADAAAAEC8P/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Qh//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxC1r//EABwQAQACAwEBAQAAAAAAAAAAAAERIQAxQVGBof/aAAgBAQABPxAZQXbkHa1gVSFFD5fMfKNMphxFe8FH8ygnF/LXc58keVn/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "neutral finish palette in play space",
            "title": "neutral finish palette in play space",
            "src": "/workplace-xg/static/55f39aa637067dd7feeb9ebe9cf5529d/2e753/neutral-finish-palette-in-play-space.jpg",
            "srcSet": ["/workplace-xg/static/55f39aa637067dd7feeb9ebe9cf5529d/69549/neutral-finish-palette-in-play-space.jpg 288w", "/workplace-xg/static/55f39aa637067dd7feeb9ebe9cf5529d/473e3/neutral-finish-palette-in-play-space.jpg 576w", "/workplace-xg/static/55f39aa637067dd7feeb9ebe9cf5529d/2e753/neutral-finish-palette-in-play-space.jpg 1152w", "/workplace-xg/static/55f39aa637067dd7feeb9ebe9cf5529d/74f4b/neutral-finish-palette-in-play-space.jpg 1728w", "/workplace-xg/static/55f39aa637067dd7feeb9ebe9cf5529d/f35b7/neutral-finish-palette-in-play-space.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2>{`Glass and metal`}</h2>
    <p>{`Glass helps to express the openness and transparency of an IBM environment.
Glass also brings natural light deep into the environment, enhancing employee wellness and productivity. Clear, translucent and back-painted glass complement the materials in IBM’s environmental toolkit. Low-iron glass is recommended for clear glass applications.`}</p>
    <p>{`Butt-joint detailing provides a clean, modern and seamless appearance. Metal accents can be a combination of matte charcoal, matte aluminum or satin stainless steel. Demountable partitions and office fronts are key applications for flexibility of use. A dark charcoal is preferred for demountable partition frames and door hardware. A matte finish should be used for these applications. Matte black, matte aluminum or satin stainless steel can be used for cabinet hardware.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUEA//EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAAB26J3ArrMblIMNIbP/8QAGxABAQEAAgMAAAAAAAAAAAAAAgEDACEEEBH/2gAIAQEAAQUC7+jSP1RTy7QqdTdUYeGZXrqgv//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/ASE//8QAHhAAAgEEAwEAAAAAAAAAAAAAAAERITFBkQIDECL/2gAIAQEABj8Co9jWV589myJhqlCFY5NXG3ghQf/EABwQAQADAAIDAAAAAAAAAAAAAAEAESEQMWFx0f/aAAgBAQABPyETXy46Ix8B4wxp9YYdPrcdIoCdZ4yC1abIaGlXs//aAAwDAQACAAMAAAAQJACA/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAx/9oACAEDAQE/EGOz/8QAFhEBAQEAAAAAAAAAAAAAAAAAEAEx/9oACAECAQE/EKMn/8QAHhABAQACAgIDAAAAAAAAAAAAAREAITFRQaFhkdH/2gAIAQEAAT8QLGFYKgaCk5/cMQDxBodj1ii+HL6GiB9sEYh1z4vZhDMAJx94m4AE7lQvvJaCrwKy4r2joVtfnP/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "glass and metal finish palette example",
            "title": "glass and metal finish palette example",
            "src": "/workplace-xg/static/a275546e9290d3da2fe721a540adcfb3/473e3/glass-and-metal-finish-palette-example.jpg",
            "srcSet": ["/workplace-xg/static/a275546e9290d3da2fe721a540adcfb3/69549/glass-and-metal-finish-palette-example.jpg 288w", "/workplace-xg/static/a275546e9290d3da2fe721a540adcfb3/473e3/glass-and-metal-finish-palette-example.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAQBAgMF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAAB29GDuFcmMydALIR//8QAHRAAAgIBBQAAAAAAAAAAAAAAAQMAAjEREhMiMv/aAAgBAQABBQJmoC/Ebjk2VDI3BHQUE//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/AWM//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8BIT//xAAcEAABBAMBAAAAAAAAAAAAAAAAARARcQIxUeH/2gAIAQEABj8CSOvjZCbPBLf/xAAdEAACAgIDAQAAAAAAAAAAAAAAARFhITFBUfBx/9oACAEBAAE/IX5XYXD6xI8FE9h0GtbaHnoQ7djMypyf/9oADAMBAAIAAwAAABCoJzz/xAAVEQEBAAAAAAAAAAAAAAAAAAAgMf/aAAgBAwEBPxCA/8QAFxEAAwEAAAAAAAAAAAAAAAAAABARMf/aAAgBAgEBPxDZW//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESExQZGxUcH/2gAIAQEAAT8QWk2AmFlOJal5/SMmWDq+pUmOqaAXteCWu5pC1PXsHS9RU5A4GycZCCwaPhjU/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "glass and metal finish palette examples",
            "title": "glass and metal finish palette examples",
            "src": "/workplace-xg/static/51bd4f8397d79e4a9e51c0b6c4474500/473e3/glass-and-metal-finish-palette-examples.jpg",
            "srcSet": ["/workplace-xg/static/51bd4f8397d79e4a9e51c0b6c4474500/69549/glass-and-metal-finish-palette-examples.jpg 288w", "/workplace-xg/static/51bd4f8397d79e4a9e51c0b6c4474500/473e3/glass-and-metal-finish-palette-examples.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDAf/EABYBAQEBAAAAAAAAAAAAAAAAAAIAAf/aAAwDAQACEAMQAAAB5vNTmxNFctAswV//xAAaEAADAAMBAAAAAAAAAAAAAAAAAQIDERJB/9oACAEBAAEFAodyOmildPbQ+uVjTM2OVHmj/8QAFREBAQAAAAAAAAAAAAAAAAAAEAH/2gAIAQMBAT8BIf/EABURAQEAAAAAAAAAAAAAAAAAABAB/9oACAECAQE/ASn/xAAfEAABAwMFAAAAAAAAAAAAAAABAAIREBIhIFFhcYH/2gAIAQEABj8CsMEbqYbjtSXxwFd7TLgNH//EABsQAQADAQADAAAAAAAAAAAAAAEAETEhQVFx/9oACAEBAAE/ITeq4JeQoS0weoj+iZC6PfEs2ZCbUyqgqrW9WeMRP//aAAwDAQACAAMAAAAQ48i+/8QAGhEAAgIDAAAAAAAAAAAAAAAAABEBIRAxUf/aAAgBAwEBPxBS6L4bY//EABoRAAICAwAAAAAAAAAAAAAAAAABECERMVH/2gAIAQIBAT8QTWLK6ax//8QAHBABAAMAAwEBAAAAAAAAAAAAAQARITFBUXGB/9oACAEBAAE/ENAdrnUup62UJOEBonjCPNmykXTV1nPkQkZRSGejEY4vB4/Y/CptGj09QB6M4Ih0H6E//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "glass and metal finish palette in lobby",
            "title": "glass and metal finish palette in lobby",
            "src": "/workplace-xg/static/05d677bbc2033b5d5c544716cc9affb7/473e3/glass-and-metal-finish-palette-in-lobby.jpg",
            "srcSet": ["/workplace-xg/static/05d677bbc2033b5d5c544716cc9affb7/69549/glass-and-metal-finish-palette-in-lobby.jpg 288w", "/workplace-xg/static/05d677bbc2033b5d5c544716cc9affb7/473e3/glass-and-metal-finish-palette-in-lobby.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.90277777777778%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAgQA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAW6FE2o1f//EABkQAAIDAQAAAAAAAAAAAAAAAAACARESE//aAAgBAQABBQLox1m9TUIphTCn/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGBABAQADAAAAAAAAAAAAAAAAADEBMqH/2gAIAQEABj8Ca9YREf/EAB0QAQACAQUBAAAAAAAAAAAAAAEAESFBUWHR8PH/2gAIAQEAAT8hoUy0OvMcNQbwOlpYNXPqTJ2noz//2gAMAwEAAgADAAAAEJgP/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Qh//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB0QAQACAgIDAAAAAAAAAAAAAAERIQAxQVFhkaH/2gAIAQEAAT8QR4dHDUB9Ye0bN8VqN5I2uWQpiG5TTa/uDJbb25rEY8O2f//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "glass and metal finish palette in collaboration space",
            "title": "glass and metal finish palette in collaboration space",
            "src": "/workplace-xg/static/93a3c9ff663fb787db37d5327c483907/2e753/glass-and-metal-finish-palette-in-collaboration-space.jpg",
            "srcSet": ["/workplace-xg/static/93a3c9ff663fb787db37d5327c483907/69549/glass-and-metal-finish-palette-in-collaboration-space.jpg 288w", "/workplace-xg/static/93a3c9ff663fb787db37d5327c483907/473e3/glass-and-metal-finish-palette-in-collaboration-space.jpg 576w", "/workplace-xg/static/93a3c9ff663fb787db37d5327c483907/2e753/glass-and-metal-finish-palette-in-collaboration-space.jpg 1152w", "/workplace-xg/static/93a3c9ff663fb787db37d5327c483907/74f4b/glass-and-metal-finish-palette-in-collaboration-space.jpg 1728w", "/workplace-xg/static/93a3c9ff663fb787db37d5327c483907/f35b7/glass-and-metal-finish-palette-in-collaboration-space.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </ImageCollection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      